import { getError } from "@/utils/helpers";
import StatuteService from "@/services/statute/StatuteService";

export const namespaced = true;

export const state = {
  statuteSingle: [],
  loading: false,
  error: null,
};

export const mutations = {
  SET_ADJUSTMENTS(state, statuteSingle) {
    state.statuteSingle = statuteSingle;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export const actions = {
  getStatute({ commit }, famId) {
    commit("SET_LOADING", true);

    StatuteService.getMain(famId)
      .then((response) => {
        commit("SET_ADJUSTMENTS", response.data.data);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },
  setDefault({ commit }) {
    commit("SET_LOADING", false);
    commit("SET_ERROR", null);
    commit("SET_ADJUSTMENTS", []);
  },
};
export const getters = {
  statuteSingle: (state) => {
    return state.statuteSingle;
  },
  loading: (state) => {
    return state.loading;
  },
  error: (state) => {
    return state.error;
  },
};
